import { render, staticRenderFns } from "./OssUploader.vue?vue&type=template&id=f1921de8"
import script from "./OssUploader.vue?vue&type=script&lang=js"
export * from "./OssUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports